
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import RoleOption from 'models/RoleOption'
import store from 'store'

import Shifts           from 'views/Shifts'
import ShiftsHeader     from 'views/ShiftsHeader'
import Shifts2          from 'views/Shifts2'
import Dailies          from 'views/Dailies'
import DailiesHeader    from 'views/DailiesHeader'
import People           from 'views/People'
import PeopleHeader     from 'views/PeopleHeader'
import Users            from 'views/Users'
import ImportCsv        from 'views/ImportCsv'
import Diagnostic       from 'views/Diagnostic'
import MaintenanceEntry from 'views/MaintenanceEntry'
import Test             from 'views/Test'
import NotFound         from 'components/NotFound'
import WeeklyStores       from 'views/WeeklyStores'
import WeeklyStoresHeader from 'views/WeeklyStoresHeader'
import WeeklyTasks       from 'views/WeeklyTasks'
import WeeklyTasksHeader from 'views/WeeklyTasksHeader'

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/shifts/:storeCode(\\d+)?/:floorCode(\\d)?/:date(20\\d{6})?/:aspect?',
    name: 'shifts',
    components: {default: Shifts, header: ShiftsHeader},
    props: {default: true, header: true},
    meta: {title: 'レジシフト'},
  }, {
    path: '/shifts2/:storeCode(\\d+)?/:floorCode(\\d)?/:date(20\\d{6})?/:aspect?',
    name: 'shifts2',
    components: {default: Shifts2, header: ShiftsHeader},
    props: {default: true, header: true},
    meta: {title: 'レジシフト(新)', role: [RoleOption.ROLE_VENDOR]},
  }, {
    path: '/dailies/:storeCode(\\d+)?/:floorCode(\\d)?/:beginDate(20\\d{6})?',
    name: 'dailies',
    components: {default: Dailies, header: DailiesHeader},
    props: {default: true, header: true},
    meta: {title: '稼働計画'},
  }, {
    path: '/people/:storeCode(\\d+)?/:floorCode(\\d)?',
    name: 'people',
    components: {default: People, header: PeopleHeader},
    props: {default: true, header: true},
    meta: {title: '個人別勤務時間'},
  }, {
    path: '/weekly_tasks/:storeCode(\\d+)?/:floorCode(\\d)?',
    name: 'weekly_tasks',
    components: {default: WeeklyTasks, header: WeeklyTasksHeader},
    props: {default: true, header: true},
    meta: {title: '週間割当'},
  }, {
    path: '/weekly_stores/:storeCode(\\d+)?/:floorCode(\\d)?',
    name: 'weekly_stores',
    components: {default: WeeklyStores, header: WeeklyStoresHeader},
    props: {default: true, header: true},
    meta: {title: '週間RE'},
  }, {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      title: 'ログイン情報',
      role: [RoleOption.ROLE_VENDOR, RoleOption.ROLE_ADMIN, RoleOption.ROLE_STAFF],
    },
  }, {
    path: '/import-csv',
    name: 'import-csv',
    component: ImportCsv,
    meta: {
      title: 'CSVインポート',
      role: [RoleOption.ROLE_VENDOR, RoleOption.ROLE_ADMIN],
    },
  }, {
    path: '/diagnostic',
    name: 'diagnostic',
    component: Diagnostic,
    meta: {
      title: 'その他の情報',
      role: [RoleOption.ROLE_VENDOR, RoleOption.ROLE_ADMIN],
    },
  }, {
    path: '/mainte',
    name: 'MaintenanceEntry',
    component: MaintenanceEntry,
    meta: {
      title: 'メンテナンス',
      role: [RoleOption.ROLE_VENDOR],
    },
  }, {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: {
      title: 'テスト',
      role: [RoleOption.ROLE_VENDOR],
    },
  }, {
    path: '/',
    redirect: {name: 'shifts'},
  }, {
    path: '*',
    component: NotFound,
  }]
})

export default router

// routeは表示されるべきか (metaが存在し、roleが認証状態に適合しているか)
export function isRouteDisplay(route) {
  const meta = route.meta
  if(meta != null && meta.title != null) {
    const role = meta.role
    return role == null || role.includes(store.state.config.auth.role)
  }
  return false
}
